import { NumericValue } from '../math/Decimal';
import { formatNumericValue } from './numberFormatter';

export const formatAreaSize = (value: NumericValue | undefined): string => `${formatNumericValue(value, 0)} ft`;
